import Furniture from './Furniture';

const STATE_LEFT = 1;
const STATE_RIGHT = 2;

export default class WaterRock extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.state = STATE_LEFT;
    this.objects = []; // objects placed on top of the rock

    this.addButton();

    //
    if (this.data.rock_x) {
      this.rock.x = this.data.rock_x;
      if (this.rock.x < 120) {
        this.state = STATE_LEFT;
        this.location.pond.waterUp();
      } else {
        this.state = STATE_RIGHT;
        this.location.pond.waterDown();
      }
    }
  }

  createAsset() {
    this.rock = this.game.make.image(0, -5, 'pond', 'rockslide'); // -25
    this.rock.anchor.set(0.5, 1);

    this.addChild(this.rock);
  }

  updateBounds() {
    this.bb = this.rock.getBounds();
    // this.bb.width = 140;
    // this.bb.height = 100;
  }

  // functions for moving furnitures like rock or log
  addObject(obj) {
    if (this.objects.indexOf(obj) === -1) {
      this.objects.push(obj);
    }
  }

  removeObject(obj) {
    const ind = this.objects.indexOf(obj);
    this.objects.splice(ind, 1);
  }

  //
  getTop(bb) {
    const bb1 = new Phaser.Rectangle();
    const bb2 = this.rock.getBounds(); // rock bounds
    const top = this.data.top[0];
    bb1.x = bb2.x + top.x;
    bb1.y = bb2.y + top.y;
    bb1.width = top.w;
    bb1.height = top.h;
    if (Phaser.Rectangle.intersects(bb, bb1)) {
      return { y: bb1.y, h: top.h, character: top.character };
    }
  }

  getSide(bb) {
    const bb1 = new Phaser.Rectangle();
    const bb2 = this.rock.getBounds(); // rock bounds
    const side = this.data.side[0];
    bb1.x = bb2.x + side.x;
    bb1.y = bb2.y + side.y;
    bb1.width = side.w;
    bb1.height = side.h;
    if (Phaser.Rectangle.intersects(bb, bb1)) {
      return { y: bb1.y, h: side.h };
    }
    return null;
  }

  //
  setLight(power) {
    super.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.rock.tint = this.tintColor;
  }

  // updateTintFL() {
  //   this.rock.tint = this.tintColor;
  // }

  //
  addButton() {
    this.rock.inputEnabled = true;
    this.rock.input.useHandCursor = true;
    this.rock.events.onInputDown.add(this.handleInputDown, this);
    this.rock.events.onInputUp.add(this.handleInputUp, this);
  }

  //
  handleInputDown(target, pointer) {
    target;
    if (this.game.deviceMetric.platform.type === 'desktop') {
      // desktop
      if (this.state === STATE_LEFT) {
        this.state = STATE_RIGHT;
        this.prevX = this.rock.x;
        const tween = this.game.add
          .tween(this.rock)
          .to({ x: 140 }, 500, Phaser.Easing.Quadratic.Out, true);
        tween.onUpdateCallback(this.updateMove, this);
        tween.onComplete.add(this.onMoveRight, this);
      } else {
        this.state = STATE_LEFT;
        this.prevX = this.rock.x;
        const tween = this.game.add
          .tween(this.rock)
          .to({ x: 0 }, 500, Phaser.Easing.Quadratic.Out, true);
        tween.onUpdateCallback(this.updateMove, this);
        tween.onComplete.add(this.onMoveLeft, this);
      }

      this.audio = this.game.sounds.playSFX('item_rock', { spriteID: 'sfx' });
    } else {
      // mobile
      this.startPos = { x: this.rock.x, y: this.rock.y };
      this.drag = true;

      this.dragDx = this.rock.x - (pointer.x - this.location.x - this.x);
      this.pointer = pointer;

      //
      this.audio = this.game.sounds
        .playSFX('item_rock', { spriteID: 'sfx', loop: true })
        .get('item_rock');
      this.audio.volume = 0;
    }
  }

  updateMove() {
    const dx = this.rock.x - this.prevX;
    this.prevX = this.rock.x;

    this.moveObjectsBy(dx);
  }

  onMoveRight() {
    this.game.sounds.stopAudioSprite('item_rock', { spriteID: 'sfx' });
    this.audio = null;
    this.location.pond.waterDown();
    this.onChange.dispatch();
  }

  onMoveLeft() {
    this.game.sounds.stopAudioSprite('item_rock', { spriteID: 'sfx' });
    this.audio = null;
    this.location.pond.waterUp();
    this.onChange.dispatch();

    //
    this.location.state.setLoopHint(this.data.hint);
  }

  handleInputUp() {
    if (this.game.deviceMetric.platform.type !== 'desktop') {
      // for mobile only
      this.drag = false;
      this.pointer = null;

      //
      this.game.sounds.stopAudioSprite('item_rock', { spriteID: 'sfx' });
      this.audio = null;

      //
      this.onChange.dispatch();

      //
      if (this.rock.x < 120) {
        this.location.state.setLoopHint(this.data.hint);
      }
    }
  }

  step(dt) {
    dt;
    // super.step(dt);

    // light
    const power = this.location.lights.getLightAt(
      this.rock.worldPosition.x,
      this.rock.worldPosition.y - (this.rock.height >> 1),
      !this.data.flashlight
    );
    if (power >= 0 && power !== this.lightPower) {
      this.lightPower = power;
      this.setLight(power);
    }

    //
    if (this.drag && this.pointer) {
      let x = -this.location.x + this.pointer.x - this.x + this.dragDx;
      x = Phaser.Math.clamp(x, 0, 140);
      const dx = x - this.rock.x;
      this.rock.x = x;
      this.moveObjectsBy(dx);

      //
      if (x < 120) {
        this.location.pond.waterUp();
      } else {
        this.location.pond.waterDown();
      }

      //
      this.audio.volume = Math.min(1, Math.abs(dx) / 2);
    }
  }

  moveObjectsBy(dx) {
    for (let i = 0; i < this.objects.length; i++) {
      const obj = this.objects[i];
      obj.x += dx;
    }
  }

  pulse(time = 1500) {
    this.game.add
      .tween(this.rock.scale)
      .to({ x: [1.2, 1, 1.2, 1, 1.2, 1], y: [1.2, 1, 1.2, 1, 1.2, 1] }, time, null, true);
  }

  destroy() {
    this.rock.events.onInputDown.remove(this.handleInputDown, this);

    super.destroy();
  }

  //
  serialize() {
    const data = super.serialize();
    data.rock_x = this.rock.x;
    return data;
  }
}
